// extracted by mini-css-extract-plugin
export default {"dropdown":"styles_dropdown__NhM0H","dropdown-items":"styles_dropdown-items__zMwfH"};